import { MutationTree } from 'vuex';
import { InvoiceRunsState } from './types';
import { deepClone } from '@/shared/utils/generalUtils';
import { SearchParams } from '@/shared/model/searchParams';
import invoiceRun, { Value } from '@/shared/model/invoiceRun';
import { DataOptions } from '@/shared/model/dataOptions';

export const mutations: MutationTree<InvoiceRunsState> = {
  setInvoiceRuns(state, payload: Value) {
    state.invoiceRuns.items = payload.value.map((x) => invoiceRun.parse(x));
    state.invoiceRuns.total = payload['@odata.count'] || 0;
    state.invoiceRuns.isLoading = false;
  },
  setInvoiceRunsTotal(state, payload: number) {
    state.invoiceRuns.total = payload;
  },
  setInvoiceRunsIsLoading(state, payload: boolean) {
    state.invoiceRuns.isLoading = payload;
  },
  setSearchParams(state, payload: SearchParams) {
    state.invoiceRuns.searchParams = deepClone(payload);
  },
  setFilter(state, payload: string) {
    state.invoiceRuns.searchParams.filter = payload;
  },
  setDataOption(state, payload: DataOptions) {
    state.invoiceRuns.searchParams.dataOption = deepClone(payload);
  },
  resetPaging(state) {
    state.invoiceRuns.searchParams.dataOption.page = 1;
    state.invoiceRuns.searchParams.dataOption.itemsPerPage = 10;
    state.invoiceRuns.searchParams.dataOption.filter = '';
    state.invoiceRuns.searchParams.filter = '';
  },
};
